import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './footer.component';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import {CheckActiveRoleModule} from '../../pipes/check-active-role/check-active-role.module';



@NgModule({
  declarations: [
    FooterComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    CheckActiveRoleModule
  ],
  exports: [
    FooterComponent
  ]
})
export class FooterModule { }
